import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const RatingContractor = () => {
  return (
    <SettingsMetaData propertyName={"Rating_Contractor"} viewPropertyName={"Performance Rating"} />
  );
};
export default RatingContractor;